import PropTypes from 'prop-types';
import React from 'react';

import { NavButton, PaginationBarNavGroup } from './styles';

/*
 * Thin chevron glyphs matching the Figma footer. Scoped to `PaginationBar`
 * rather than editing the shared `ravenjs/lib/SvgIcon` chevrons (which are
 * circular arrows). Uses `currentColor` so the button color tokens drive the
 * enabled/disabled states.
 */
const ChevronLeftIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
        <path
            d="M12.5 15L7.5 10L12.5 5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

const ChevronRightIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
        <path
            d="M7.5 5L12.5 10L7.5 15"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

/*
 * The prev/next chevron controls for the Quartz pagination footer.
 */
function PaginationBarNav({ currentPage, lastPage, onPrev, onNext }) {
    const isPrevDisabled = currentPage <= 1;
    const isNextDisabled = currentPage >= lastPage;

    return (
        <PaginationBarNavGroup>
            <NavButton
                type="button"
                aria-label="Previous page"
                disabled={isPrevDisabled}
                onClick={isPrevDisabled ? undefined : onPrev}
            >
                <ChevronLeftIcon />
            </NavButton>
            <NavButton
                type="button"
                aria-label="Next page"
                disabled={isNextDisabled}
                onClick={isNextDisabled ? undefined : onNext}
            >
                <ChevronRightIcon />
            </NavButton>
        </PaginationBarNavGroup>
    );
}

PaginationBarNav.propTypes = {
    currentPage: PropTypes.number,
    lastPage: PropTypes.number,
    onNext: PropTypes.func,
    onPrev: PropTypes.func,
};

PaginationBarNav.defaultProps = {
    currentPage: 1,
    lastPage: 1,
    onNext: () => {},
    onPrev: () => {},
};

export default PaginationBarNav;
